export default "__VITE_ASSET__Dtgreb6Z__"